import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

export const PersonalIcon = (props: IconProps): JSX.Element => {
  return (
    <Icon viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.9008 24.2C14.2282 24.2 8.80078 18.7726 8.80078 12.1C8.80078 5.4274 14.2282 0 20.9008 0C27.5734 0 33.0008 5.4274 33.0008 12.1C33.0008 18.7726 27.5734 24.2 20.9008 24.2ZM20.9008 2.2C15.4426 2.2 11.0008 6.6418 11.0008 12.1C11.0008 17.5582 15.4426 22 20.9008 22C26.359 22 30.8008 17.5582 30.8008 12.1C30.8008 6.6418 26.359 2.2 20.9008 2.2Z"
        fill="currentColor"
      />
      <path
        d="M38.5 43.9999H3.3C1.4806 43.9999 0 42.5193 0 40.6999C0 40.5503 0.0308001 36.9929 2.695 33.4399C4.246 31.3719 6.369 29.7285 9.0068 28.5581C12.2276 27.1259 16.2294 26.3999 20.9 26.3999C25.5706 26.3999 29.5724 27.1259 32.7932 28.5581C35.431 29.7307 37.554 31.3719 39.105 33.4399C41.7692 36.9929 41.8 40.5503 41.8 40.6999C41.8 42.5193 40.3194 43.9999 38.5 43.9999ZM20.9 28.5999C13.2286 28.5999 7.568 30.6965 4.5298 34.6631C2.2528 37.6353 2.2022 40.6735 2.2 40.7043C2.2 41.3071 2.6928 41.7999 3.3 41.7999H38.5C39.1072 41.7999 39.6 41.3071 39.6 40.6999C39.6 40.6735 39.5494 37.6353 37.2702 34.6631C34.2298 30.6965 28.5692 28.5999 20.9 28.5999Z"
        fill="currentColor"
      />
    </Icon>
  );
};
